module.exports = __webpack_public_path__ + "media/images/BIIMainlogo-514f75d3.png";